import {
    TWCCL_END_DETAILS,
    TWCCL_INITIAL_DETAILS,
    TWCCL_INSTALLER_DETAILS
} from 'common/application.const/Licence/MyLicence/TWCCLLicence';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatTWCCL = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let installerDetails = [];


    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);

    if (licenceDetails && licenceDetails.WiringInstallerList && licenceDetails.WiringInstallerList.length > 0) {
        installerDetails = licenceDetails?.WiringInstallerList.map((value: any, i: number) => ({
            'wiring-installer-no': value?.WILicenceNo ?? '-',
            'wiring-installer-name': value?.WIName ?? '-',
            'status': value?.WILicenceStatus ?? '-'
        }));
    }

    licence = {
        id: 'telecommunication-wiring-contractor-class-licence',
        formID: 'telecommunication-wiring-contractor-class-licence',
        hasError: true,
        title: 'Licence Details',
        values: {
            [`${TWCCL_INITIAL_DETAILS}-service-provided`]: licenceDetails?.ServiceDetails?.ServicesProvidedDesc ?? '-',
            [`${TWCCL_INSTALLER_DETAILS}-list`]: installerDetails ?? [...installerDetails],
            [`${TWCCL_END_DETAILS}-proof-of-certificate`]: licenceDetails?.SupportingDocumentsAPImport?.ProofOfCertificate ?? '-',
        }
    };

    return licence;
};

const twcclPayload = {
    formatTWCCL
};

export default twcclPayload;
